module.exports = __webpack_public_path__ + "img/c.57d06293.svg";